import { request } from "./client";

export function getProperties(params) {
  return request({ method: "GET", url: "/api/properties", params });
}

export function getProperty(id) {
  return request({ method: "GET", url: `/api/properties/${id}` });
}

export function createProperty(data) {
  return request({ method: "POST", url: "/api/properties", data });
}

export function updateProperty(id, data) {
  return request({ method: "PUT", url: `/api/properties/${id}`, data });
}

export function deleteProperty(id) {
  return request({ method: "DELETE", url: `/api/properties/${id}` });
}